import { inject, Injectable } from '@angular/core'
import { FeathersService } from '../../feathers.service'
import { SentEmail } from '../../../models/sentEmail'
import { ClientMessage, EmailClientMessage } from '../../../models/clientMessage'
import { Observable } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { UsersService } from '../users.service'

@Injectable({
  providedIn: 'root',
})
export class ClientMessagesHistoryService {
  private feathers = inject(FeathersService)
  private usersService = inject(UsersService)

  getMessagesPaginated(limit = 20, skip = 0) {
    return this.usersService.getAllUsersWithContactsCached().pipe(
      switchMap((users) => {
        return this.feathers
          .find(SentEmail, {
            $limit: limit,
            $skip: skip,
            $sort: {
              updatedAt: -1,
            },
          })
          .pipe(
            map((sentEmails: SentEmail[]) => {
              return sentEmails.map((sentEmail) => EmailClientMessage.createFromSentEmail(sentEmail, users))
            }),
          )
      }),
    )
  }

  getAllMessages(): Observable<ClientMessage[]> {
    // TODO paginate, filter
    // TODO combine with sent sms

    return this.usersService.getAllUsersWithContactsCached().pipe(
      switchMap((users) => {
        return this.feathers.find(SentEmail).pipe(
          map((sentEmails: SentEmail[]) => {
            return sentEmails.map((sentEmail) => EmailClientMessage.createFromSentEmail(sentEmail, users))
          }),
        )
      }),
    )
  }
}
